import api from './BaseApi';

export const syncFlightsFromCirium = async (payload) => {
    try {
        const response = await api.post('/admin/flights/sync', payload);
        return response; 
    } catch (error) {
        console.error('Sync flights error:', error);
        return error;
    }
};

export const getFlights = async (params) => {
    try {
        const response = await api.get('/admin/flights', { params });
        return response.data;
    } catch (error) {
        console.error('Get flights error:', error);
    }
};

export const getFlightDetails = async (id) => {
    try {
        const response = await api.get(`/admin/flights/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get flight details error:', error);
        return error;
    }
};

export const updateFlightStatus = async (id, payload) => {
    try {
        const response = await api.patch(`/admin/flights/${id}/status`, payload);
        return response;
    } catch (error) {
        console.error('Update flight status error:', error);
        throw error;
    }
};

export const updateFlight = async (id, payload) => {
    try {
        const response = await api.put(`/admin/flights/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update flight error:', error);
        throw error;
    }
};

export const deleteManualFlight = async (id) => {
    try {
        const response = await api.delete(`/admin/flights/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete flight error:', error);
        return error;
    }
};
